import { useSetAppSearch } from "@/components/routes/app-route.hooks";
import { MenuItemProps, MenuCheckboxItem } from "@/components/ui/primitives/menu-item";
import { useAppFilter } from "@/hooks/use-app-filter";

export function DissolveLayerFilterItem({ variant }: MenuItemProps) {
    const { set } = useSetAppSearch()
    const { isDissolveEnabled } = useAppFilter();

    return (
        <MenuCheckboxItem
            variant={variant}
            checked={isDissolveEnabled}
            onClick={() => {
                set(({ f, ...prev }) => ({
                    ...prev,
                    f: {
                        ...f,
                        dissolve: !isDissolveEnabled,
                    }
                }))
            }}
        >
            Show All Services
        </MenuCheckboxItem>
    )
}
